import { createAsyncThunk } from '@reduxjs/toolkit';

import ApplicationProcessApi from 'api/curo/ApplicationProcessApi';
import { ApplicationProcessActionTypes } from 'enums/curo/ApplicationProcessActionTypes';

export const createGetPlaidLinkTokenThunk = (api: ApplicationProcessApi) =>
  createAsyncThunk(ApplicationProcessActionTypes.GetPlaidLinkToken, async () => {
    const response = await api.getPlaidLinkToken();
    return response;
  });
